import {
  Directive,
  Input,
  ViewContainerRef,
  OnInit,
  Type,
  ComponentRef,
} from '@angular/core';
import { EstimateComponent } from 'projects/estimate/src/app/components/estimate-input/estimate.component';
import { EstimateOutputComponent } from 'projects/estimate/src/app/components/estimate-output/estimate-output.component';
import { appMeta } from '../interfaces/appMeta';
import { PostgenieSideMenu } from 'projects/postgenie/src/app/pages/side-menu/side-menu.component';
import { PostgenieHomeComponent } from 'projects/postgenie/src/app/pages/home/home.component';
import { PostgenieMainComponent } from 'projects/postgenie/src/app/pages/main/main.component';

// Define a mapping from your identifier to the actual component classes
const componentMapper: {
  [key: string]: { input: Type<any>; output: Type<any> };
} = {
  estimate: {
    input: EstimateComponent,
    output: EstimateOutputComponent,
  },
  postgenie: {
    input: PostgenieSideMenu,
    output: PostgenieMainComponent,
  },
};

@Directive({
  selector: '[appDynamicLoader]',
})
export class DynamicLoaderDirective {
  @Input() set appDynamicLoader(appMeta: appMeta) {
    this.initApp(appMeta);
  }
  constructor(private viewContainerRef: ViewContainerRef) {}

  initApp(appMeta: appMeta) {
    // Clear the container
    this.viewContainerRef.clear();

    // Get the component type
    const componentType = componentMapper[appMeta.componentType][appMeta.stage];

    // Create the component
    const componentRef: ComponentRef<any> =
      this.viewContainerRef.createComponent(componentType);

    // Assign any @Input properties to the component instance
    if (componentRef.instance.hasOwnProperty('subscriptionId')) {
      componentRef.instance.subscriptionId = appMeta.subscriptionId;
    }
  }
}
